module.exports = __webpack_public_path__ + "static/media/79.b738d250.png";